import { userFacingError } from "./authorization";

export const AVATAR_MEDIA_TYPES = [
  "image/png",
  "image/jpeg",
  "image/webp",
] as const;
export type AvatarMediaType = (typeof AVATAR_MEDIA_TYPES)[number];

export const AVATAR_MAX_BYTES = 2 * 1024 * 1024;

export function isAvatarMediaType(
  mediaType: string
): mediaType is AvatarMediaType {
  return (AVATAR_MEDIA_TYPES as readonly string[]).includes(mediaType);
}

export const AVATAR_KEY_REGEX = /^[a-zA-Z0-9_-]+\.(png|jpg|webp)$/;

export function isValidAvatarKey(key: string): boolean {
  return AVATAR_KEY_REGEX.test(key);
}

export function assertAvatarPayload(args: { data: string; mediaType: string }) {
  if (!isAvatarMediaType(args.mediaType)) {
    throw userFacingError(
      `Unsupported avatar type ${args.mediaType}. Use PNG, JPEG, or WebP.`
    );
  }
  const sizeBytes = atob(args.data).length;
  if (sizeBytes > AVATAR_MAX_BYTES) {
    throw userFacingError(
      `Avatar exceeds ${AVATAR_MAX_BYTES / 1024 / 1024} MB limit`
    );
  }
}
